import { get } from "lodash";
import mediator from "@tvg/mediator";
import tvgConf from "@tvg/conf";
import { COMMON_EVENT_NAMES } from "../../constants";
import { track } from "../../amplitude";
import { BaseEventProps } from "../../types";
import { MediatorEventType, EventProps } from "./types";
import { EVENT_NAME } from "./constants";

export default () => {
  const tvgConfig = tvgConf();
  const mobileDomain = get(tvgConfig, "domain.mobile");

  mediator.base.subscribe(
    MediatorEventType.BET_ON_MOBILE_MODAL_CTA_CLICKED,
    () => {
      track<EventProps>(EVENT_NAME.BET_ON_MOBILE_MODAL_CTA_CLICKED, {
        [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
        [BaseEventProps.MODULE]: "bet_on_mobile_modal",
        [BaseEventProps.LINK_URL]: mobileDomain,
        [BaseEventProps.LINK_TEXT]: "go_to_fanduel_racing_on_your_browser"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.BET_ON_MOBILE_MODAL_VIEWED, () => {
    track<EventProps>(EVENT_NAME.BET_ON_MOBILE_MODAL_VIEWED, {
      [BaseEventProps.MODULE]: "bet_on_mobile_modal"
    });
  });
};
